import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const MedicalLabTechnologyCoursePage: React.FC = () => {
  const medicalLabTechData = {
    title: "Bachelor of Medical Laboratory Technology",
    shortName: "BMLT",
    duration: "3 Years",
    description: "A comprehensive program training students in laboratory testing, sample analysis, and diagnostic procedures essential for modern healthcare delivery.",
    overview: "Bachelor of Medical Laboratory Technology (BMLT) is a specialized healthcare program that prepares students to become skilled medical laboratory professionals. The course covers various aspects of clinical pathology, microbiology, biochemistry, hematology, immunology, and molecular diagnostics. Students learn to operate sophisticated laboratory equipment, perform diagnostic tests, maintain quality control, and provide accurate results that aid in disease diagnosis and treatment monitoring.",
    eligibility: [
      "Completed 10+2 with Physics, Chemistry, and Biology",
      "Minimum 50% aggregate marks (45% for SC/ST/OBC)",
      "Age: 17-25 years",
      "Medical fitness certificate required",
      "Good analytical and observational skills",
      "English proficiency essential"
    ],
    careerProspects: {
      roles: [
        "Medical Laboratory Technician",
        "Medical Lab Scientist",
        "Pathology Assistant",
        "Quality Control Analyst",
        "Laboratory Supervisor",
        "Research Laboratory Technician",
        "Blood Bank Technician",
        "Microbiology Technician",
        "Biochemistry Analyst",
        "Laboratory Manager"
      ],
      industries: [
        "Hospitals and Clinics",
        "Diagnostic Laboratories",
        "Research Institutions",
        "Pharmaceutical Companies",
        "Blood Banks",
        "Government Health Services",
        "Veterinary Laboratories",
        "Forensic Laboratories",
        "Public Health Laboratories",
        "Private Diagnostic Centers"
      ],
      averageSalary: "₹2.5-6 LPA (varies by experience and specialization)",
      topRecruiters: [
        "SRL Diagnostics",
        "Dr. Lal PathLabs",
        "Metropolis Healthcare",
        "Thyrocare Technologies",
        "Apollo Diagnostics",
        "AIIMS",
        "PGIMER",
        "Tata Memorial Hospital",
        "Fortis Healthcare",
        "Max Healthcare"
      ]
    },
    curriculum: [
      {
        year: 1,
        subjects: [
          "Anatomy and Physiology",
          "Biochemistry",
          "Basic Pathology",
          "Microbiology",
          "Basic Mathematics",
          "English Communication",
          "Computer Applications",
          "Laboratory Safety"
        ]
      },
      {
        year: 2,
        subjects: [
          "Clinical Pathology",
          "Hematology",
          "Clinical Biochemistry",
          "Medical Microbiology",
          "Immunology and Serology",
          "Histopathology Techniques",
          "Quality Control",
          "Laboratory Management"
        ]
      },
      {
        year: 3,
        subjects: [
          "Advanced Hematology",
          "Molecular Diagnostics",
          "Clinical Cytogenetics",
          "Transfusion Medicine",
          "Research Methodology",
          "Hospital Internship",
          "Project Work",
          "Professional Ethics"
        ]
      }
    ],
    admissionProcess: [
      "Apply to medical colleges offering BMLT",
      "Merit-based selection or entrance examination",
      "Counseling and document verification",
      "Medical fitness examination",
      "Fee payment and admission",
      "Orientation program",
      "Begin academic session",
      "Complete mandatory internship"
    ],
    topColleges: [
      {
        name: "All India Institute of Medical Sciences",
        location: "New Delhi",
        fees: "₹8,000 PA",
        ranking: "Premier Government Institute"
      },
      {
        name: "Postgraduate Institute of Medical Education",
        location: "Chandigarh",
        fees: "₹10,000 PA",
        ranking: "Top Government College"
      },
      {
        name: "Christian Medical College",
        location: "Vellore, Tamil Nadu",
        fees: "₹1.2 LPA",
        ranking: "Prestigious Private College"
      },
      {
        name: "Kasturba Medical College",
        location: "Manipal, Karnataka",
        fees: "₹2.5 LPA",
        ranking: "Deemed University"
      },
      {
        name: "MGM Institute of Health Sciences",
        location: "Mumbai, Maharashtra",
        fees: "₹2 LPA",
        ranking: "Well Established"
      }
    ],
    skills: [
      "Laboratory Techniques",
      "Equipment Operation",
      "Sample Collection",
      "Quality Control",
      "Data Analysis",
      "Attention to Detail",
      "Safety Protocols",
      "Computer Skills",
      "Problem Solving",
      "Time Management",
      "Communication Skills",
      "Technical Documentation"
    ],
    futureScope: "Medical Laboratory Technology is evolving rapidly with automation, artificial intelligence, and molecular diagnostics. Future opportunities include specialization in areas like genetic testing, personalized medicine, point-of-care testing, and digital pathology. The integration of AI and machine learning in laboratory diagnostics is creating new roles in data analysis and laboratory informatics. Telemedicine and home healthcare services are also expanding opportunities for remote laboratory services.",
    faqs: [
      {
        question: "What is the career growth potential in medical laboratory technology?",
        answer: "Career growth includes becoming a laboratory supervisor, laboratory manager, quality assurance officer, or specializing in specific areas like molecular diagnostics. Many professionals also pursue higher education or start their own diagnostic laboratories."
      },
      {
        question: "Is there scope for higher education after BMLT?",
        answer: "Yes, you can pursue M.Sc in Medical Laboratory Technology, MBA in Hospital Management, or specialized certifications in areas like molecular diagnostics, cytogenetics, or laboratory management."
      },
      {
        question: "What are the working conditions like for lab technicians?",
        answer: "Most lab technicians work in clean, well-equipped laboratory environments. The work involves shift duties in hospitals, and professionals must follow strict safety protocols when handling biological samples."
      },
      {
        question: "Can I work internationally with a BMLT degree?",
        answer: "Yes, many countries have opportunities for medical laboratory technologists. You may need additional certifications or meet specific country requirements for international practice."
      },
      {
        question: "How important is the internship component?",
        answer: "The internship is crucial as it provides hands-on experience in real laboratory settings, exposure to various diagnostic procedures, and helps develop practical skills essential for employment."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {medicalLabTechData.title} ({medicalLabTechData.shortName})
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={medicalLabTechData} />
      </div>
    </div>
  );
};

export default MedicalLabTechnologyCoursePage;